// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".StreetAddressFields-module-container-2zZCG{display:grid;grid-gap:24px;gap:24px}.StreetAddressFields-module-addressFields-1KBTu{display:flex;flex-wrap:wrap;align-items:flex-start}@media(min-width: 960px){.StreetAddressFields-module-addressFields-1KBTu>div:first-child{padding-inline-end:20px}}.StreetAddressFields-module-streetName-3rmnN{width:100%;margin-bottom:24px}@media(min-width: 960px){.StreetAddressFields-module-streetName-3rmnN{width:65%}}.StreetAddressFields-module-streetNumber-IF2hk{width:100%;margin-bottom:24px}@media(min-width: 960px){.StreetAddressFields-module-streetNumber-IF2hk{width:35%}}.StreetAddressFields-module-streetAdditional-1iM-g{width:100%;margin-bottom:24px}", ""]);
// Exports
exports.locals = {
	"container": "StreetAddressFields-module-container-2zZCG",
	"addressFields": "StreetAddressFields-module-addressFields-1KBTu",
	"streetName": "StreetAddressFields-module-streetName-3rmnN",
	"streetNumber": "StreetAddressFields-module-streetNumber-IF2hk",
	"streetAdditional": "StreetAddressFields-module-streetAdditional-1iM-g"
};
module.exports = exports;
